import React, {useState} from 'react';
import AddOrUpdateGame from "./AddOrUpdateGame/AddOrUpdateGame";
import GameCard from "./GameCard/GameCard";
import gameService from "../../../../Service/EntityService";

const GameConstructor = ({games, setGames, setIsLoad, setErrorMessage, gameEntityName, levels}) => {
    const [activeGame, setActiveGame] = useState(null)
    console.log('games', games)
    const deleteGame = async(gameId)=>{
        try{
            await gameService.delete(gameEntityName, gameId)
            return true
        } catch (e) {
            console.log(e)
            return false
        }
    }

    const saveGame = async ()=>{
        setIsLoad(false)
        const isCreateNewTask = !activeGame.id
        const executeFunc = isCreateNewTask? gameService.add : gameService.update
        try {
            const game = await executeFunc(gameEntityName, activeGame)
            if(isCreateNewTask){
                setGames([...games, game])
                setActiveGame(game)
            } else {
                setGames(games.map(g => {
                    if(g.id === activeGame.id){
                          return game
                    }
                    return g
                }))
            }
        } catch (e) {
            console.log(e)
            setErrorMessage(e)
        } finally{
            setIsLoad(true)
        }
    }

    return (
        <>
            {!activeGame?
                    <div>
                        {games.map((game,index)=>{
                            return(
                                <div key={'game_list_'+index}>
                                    <GameCard game={game} delGame={deleteGame} updatedGame={()=>setActiveGame(game)} />
                                </div>
                            )
                        })}
                        <div onClick={()=>{
                            setActiveGame(gameService.getEmptyGame())
                        }} className={'btn'}>Добавить</div>
                    </div>:
                    <div>
                        <AddOrUpdateGame levels={levels} changeData={g=>setActiveGame(g)} game={activeGame}/>

                        <div onClick={async(e)=>{
                            setIsLoad(false)
                            e.target.innerText = 'Сохраняю...'
                            await saveGame()
                            setTimeout(()=>{
                                e.target.innerText = 'Сохранить'
                                setIsLoad(true)
                            },1200)
                        }} className={'btn'}>Сохранить</div>
                        <div onClick={()=>{
                           setActiveGame(null)
                        }} className={'btn'}>Закрыть</div>
                    </div>
            }

        </>
        )
};

export default GameConstructor;